// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__XCury","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__CGLPY"};